import { render } from "./EmojiExpression.vue?vue&type=template&id=db718b34&scoped=true"
import script from "./EmojiExpression.vue?vue&type=script&lang=js"
export * from "./EmojiExpression.vue?vue&type=script&lang=js"

import "./EmojiExpression.vue?vue&type=style&index=0&id=db718b34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db718b34"

export default script